import { Button } from "@/components/core/buttons/button";
import { Form, FormControl, FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form";
import Select from "@/components/core/forms/select.tsx";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { type UserFormSchema, userFormSchema } from "../types/user";

export default function UserProfilePrivilegeForm({
	data,
	onSubmit,
}: {
	data?: UserFormSchema;
	onSubmit: (data: UserFormSchema, reset: () => void) => void;
}) {
	const form = useForm<UserFormSchema>({
		resolver: zodResolver(userFormSchema),
		defaultValues: {
			id: data?.id,
			first_name: data?.first_name || "",
			middle_name: data?.middle_name || "",
			last_name: data?.last_name || "",
			suffix: data?.suffix || "",
			email: data?.email || "",
			contact_number: data?.contact_number || "",
			sex: data?.sex || "",
			birthdate: data?.birthdate || "",
			preferred_gender: data?.preferred_gender || "",
			zipcode: data?.zipcode || "",
			city_code: data?.city?.name || "",
			barangay: data?.barangay || "",
			address_1: data?.address_1 || "",
			address_2: data?.address_2 || "",
			preferred_middle_initials: data?.preferred_middle_initials || "",
			region_code: data?.region?.name || "",
			province_code: data?.province?.name || "",
			post_as_judge: data?.post_as_judge || false,
			post_as_multiple_role: data?.post_as_multiple_role || false,
		},
	});

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(onSubmit)}>
				<div className="flex flex-col w-full gap-6">
					<div className="flex flex-row items-center justify-between w-full gap-4">
						<div className="inline-flex flex-col w-auto">
							<span className="text-xl text-foreground-dark font-semibold">Account Privilege</span>
							<span className="text-base text-foreground/70">Manage privilege settings to control how you post and interact within the platform.</span>
						</div>
					</div>
					<div className="flex flex-col w-full gap-4">
						<div className="grid grid-cols-12 w-full gap-x-4 gap-y-3">
							<div className="col-span-6 w-full">
								<FormField
									control={form.control}
									name="post_as_judge"
									render={({ field }) => (
										<FormItem>
											<div className="flex flex-col w-full">
												<FormLabel>Post As Judge</FormLabel>
												<FormDescription />
											</div>
											<FormGroup>
												<Select
													onValueChange={field.onChange}
													defaultValue={field.value}
													options={[
														{
															value: true,
															label: "Yes",
														},
														{
															value: false,
															label: "No",
														},
													]}
												/>
											</FormGroup>
										</FormItem>
									)}
								/>
							</div>
							<div className="col-span-6 w-full">
								<FormField
									control={form.control}
									name="post_as_multiple_role"
									render={({ field }) => (
										<FormItem>
											<div className="flex flex-col w-full">
												<FormLabel>Post As Multiple Role</FormLabel>
												<FormDescription />
											</div>
											<FormGroup>
												<Select
													onValueChange={field.onChange}
													defaultValue={field.value}
													options={[
														{
															value: true,
															label: "Yes",
														},
														{
															value: false,
															label: "No",
														},
													]}
												/>
											</FormGroup>
										</FormItem>
									)}
								/>
							</div>
						</div>
						<div className="flex flex-row w-full mt-2">
							<Button type="submit">Save Changes</Button>
						</div>
					</div>
				</div>
			</form>
		</Form>
	);
}
